import {GET_PRODUCTS} from "../actionTypes";

export const  Product = (state=[], action)=>{
	switch (action.type){
		case GET_PRODUCTS:
			return action.payload;
		default:
			return  state;
	}
}
